/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const anchormenu = () => {
  const parents = document.querySelectorAll('.c-content-tabs');
  parents.forEach(container => {
    const mainNavLinks = container.querySelectorAll(
      '.js-navigation-scroll-link',
    );
    const sections = [];
    mainNavLinks.forEach(link => {
      sections.push(container.querySelector(link.hash));
    });

    window.addEventListener('scroll', event => {
      const fromTop = window.pageYOffset;

      sections.forEach(s => {
        if (s) {
          const relativePosition =
            s.getBoundingClientRect().top +
            document.documentElement.scrollTop -
            80;
          if (
            relativePosition <= fromTop &&
            relativePosition + s.offsetHeight > fromTop
          ) {
            mainNavLinks.forEach(link => {
              if (link.hash === `#${s.id}`) {
                link.classList.add('is-active');
              }
            });
          } else {
            mainNavLinks.forEach(link => {
              if (link.hash === `#${s.id}`) {
                link.classList.remove('is-active');
              }
            });
          }
        }
      });
    });

    const dropDownValue = container.querySelector('.js-select-scroll select');
    if (dropDownValue) {
      dropDownValue.addEventListener('change', e => {
        if (e.target.value !== 0) {
          window.location.hash = e.target.value;
        }
      });
    }
  });
};

export default anchormenu;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/anchormenu.js